
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1200 800"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#005BBB","d":"M0 0h1200v800H0z"}}),_c('path',{attrs:{"fill":"#FFD500","d":"M0 400h1200v400H0z"}})])
          )
        }
      }
    